import React from 'react';
import { useLocation } from 'react-router-dom';
import { useConnectivityStatus } from '../hooks/useConnectivityStatus.ts';
import { isBackendRequiredPath } from '../utils/offlineCapabilities.ts';
import { isPWAInstalled } from '../utils/deviceUtils.ts';
import './OfflineRestrictionBanner.css';

const OfflineRestrictionBanner: React.FC = () => {
  const location = useLocation();
  const { isOnline, isBackendOnline, backendChecked } = useConnectivityStatus();
  const backendAvailable = isOnline && isBackendOnline;
  const requiresBackend = isBackendRequiredPath(location.pathname);

  if (!backendChecked && isOnline) {
    return null;
  }

  if (!isOnline && !isPWAInstalled()) {
    return (
      <div className="offline-banner warning">
        <span>Você está offline e o modo offline só funciona com a PWA instalada.</span>
      </div>
    );
  }

  if (!isOnline) {
    return (
      <div className="offline-banner warning">
        <span>Você está offline. Dados locais disponíveis; sincronização pausada.</span>
      </div>
    );
  }

  if (!backendAvailable) {
    return (
      <div className={`offline-banner ${requiresBackend ? 'error' : 'warning'}`}>
        <span>
          {requiresBackend
            ? 'Este módulo exige conexão com o backend. As ações estão desabilitadas.'
            : 'Backend indisponível. Operações online e sincronização estão suspensas.'}
        </span>
      </div>
    );
  }

  return null;
};

export default OfflineRestrictionBanner;
